module.exports = __webpack_public_path__ + "img/food-bowl.76f791c8.gif";